export const operatorsRatingManagement = [
  {
    name: "Марія S.",
    avgCheck: "780₴",
    upsell: "97%",
    leads: 60,
    salary: "6 000₴",
    combo: 20,
  },
  {
    name: "Петро K.",
    avgCheck: "720₴",
    upsell: "92%",
    leads: 58,
    salary: "5 800₴",
    combo: 15,
  },
  {
    name: "Ви",
    avgCheck: "680₴",
    upsell: "89%",
    leads: 54,
    salary: "5 500₴",
    combo: 12,
  },
  {
    name: "Анастасія L.",
    avgCheck: "650₴",
    upsell: "85%",
    leads: 50,
    salary: "5 200₴",
    combo: 8,
  },
  {
    name: "Іван P.",
    avgCheck: "600₴",
    upsell: "80%",
    leads: 46,
    salary: "5 000₴",
    combo: 5,
  },
];
